'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _VideoPlaybackHeartbeat = require('./events/VideoPlaybackHeartbeat');

var _VideoPlaybackHeartbeat2 = _interopRequireDefault(_VideoPlaybackHeartbeat);

var _createTracker = require('./utils/createTracker');

var _createTracker2 = _interopRequireDefault(_createTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VideoActivitySnowplowTracker = function () {
  function VideoActivitySnowplowTracker(config, context) {
    _classCallCheck(this, VideoActivitySnowplowTracker);

    if (this.instance) {
      return this.instance;
    }

    this.instance = this;
    this.__type = 'VideoActivitySnowplowTracker';

    var appVersion = config.appVersion,
        globalSnowplowName = config.globalSnowplowName,
        intervalMs = config.intervalMs,
        trackerName = config.trackerName,
        trackerSettings = config.trackerSettings,
        userId = config.userId;


    (0, _createTracker2.default)(globalSnowplowName, userId, trackerName, trackerSettings);

    this.heartbeat = new _VideoPlaybackHeartbeat2.default({
      appVersion: appVersion,
      globalSnowplowName: globalSnowplowName,
      intervalMs: intervalMs,
      trackerName: trackerName,
      trackerSettings: trackerSettings,
      userId: userId
    }, context);
  }

  _createClass(VideoActivitySnowplowTracker, [{
    key: 'destructor',
    value: function destructor() {
      this.stop();
      this.heartbeat.destructor();
      this.instance = null;
    }
  }, {
    key: 'updateHeartbeatIntervalMs',
    value: function updateHeartbeatIntervalMs(intervalMs) {
      this.heartbeat.updateHeartbeatIntervalMs(intervalMs);
    }
  }, {
    key: 'updateCurrentPlaybackTimeMs',
    value: function updateCurrentPlaybackTimeMs(currentPlaytimeMs) {
      this.heartbeat.updateCurrentPlaybackTimeMs(currentPlaytimeMs);
    }
  }, {
    key: 'updatePlaybackRate',
    value: function updatePlaybackRate(currentPlaybackRate) {
      this.heartbeat.updatePlaybackRate(currentPlaybackRate);
    }
  }, {
    key: 'start',
    value: function start() {
      this.heartbeat.start();
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.heartbeat.stop();
    }
  }, {
    key: 'setContext',
    value: function setContext(context) {
      this.heartbeat.setEventContext(context);
    }
  }]);

  return VideoActivitySnowplowTracker;
}();

exports.default = VideoActivitySnowplowTracker;
module.exports = exports['default'];